<template>
  <v-list v-if="loading">
    <v-skeleton-loader v-for="i in 3" :key="i" type="list-item" :style="'opacity:' + (5 - i) / 4 + ';'">
    </v-skeleton-loader>
  </v-list> 

  <v-list v-else-if="counterList && counterList[0]" dense class="py-0 OddMarkedList">
    <v-row v-for="item in counterList" :key="item.CounterId" no-gutters class="px-2">
      <v-text-field v-model="item.editValue" :loading="item.loading" :label="item.Name"
        :placeholder="item.LastValue || '0'" persistent-placeholder clearable hide-details="auto"
        :hint="item.LastValue ? $t('servicesystem.common_objects.counter.last_value_was', { vkey: item.LastValue, dkey: i18nFormatDate(item.LastValueDate) }) : undefined"
        :error="item.errors && item.errors.length > 0" :error-messages="item.errors" @blur="setCounter(item)">
        <!-- append-outer-icon="mdi-clipboard-text-clock"
          @click:append-outer="viewHistory" -->
      </v-text-field>
    </v-row>
    <v-row no-gutters>
      <v-btn class="linkStyleButton" @click="viewHistory()">
        {{$t('servicesystem.common_objects.commonterms.view_more')}}
      </v-btn>
    </v-row>
    <MachineCounterDialog :machineId="machineId" :externaltrigger="dialogtrigger">
    </MachineCounterDialog>
  </v-list>

  <v-list-item v-else>
    {{$t("servicesystem.common_objects.fallbackterms.no_counters")}}
  </v-list-item>
</template>


<script>
import ClientAPIMixin from "@/api/ClientAPIMixin";
import MachineCounterDialog from "@/components/Dialogs/MachineCounterDialog.vue";
import Vue from "vue";

export default {
  name: "MachineCountersCardContent",
  props: {
    CounterList: Array,
    machineId: [Number, String],
  }, 
  components: {
    MachineCounterDialog,
  },
  mixins: [ClientAPIMixin],

  data() {
    return {
      loading: false,
      counterList: [],
      dialogtrigger: 1,
    };
  },

  mounted() {
    this.getCounters();
  },

  methods: {
    async getCounters() {
      this.loading = true;
      await this.getCountersByMachineId(this.machineId)
          .then((response) => {
              this.counterList = response;
              for (let counter of this.counterList) {
                  counter.editValue = counter.Value;
              }
              this.loading = false;
          });
    },

    async setCounter(counter) {
      if (counter.Value === counter.editValue) {
        return;
      }
      else {
        counter.Value = counter.editValue;
         Vue.set(counter, 'loading', true);
        await this.setMachineCounter(counter)
          .then(() => {
            counter.errors = null;
          })
          .catch((error) => {
            if (error.status != 204) {
              console.error(error);
              counter.errors = 'Error saving value.';
            }
          })
          .finally(() => {
            Vue.set(counter, 'loading', false);
          });
      }
    },

    viewHistory() {
      this.dialogtrigger++;
    },
  },

  computed: {},

  watch: {
    CounterList: function (val) {
      console.log('counterlist', val);
    },
    machineId: function () {
      this.getCounters();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>